export default [
    {
        name: 'title',
        sortField: 'title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'description',
        sortField: 'description',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:link',
        sortField: 'link',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'regions',
        sortField: 'regions',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:keys_count',
        sortField: 'keys_count',
        dataClass: 'ral',
        type: 'number',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'updated_at',
        sortField: 'last_updated_at',
        type: 'dateRange',
        useInFilter: false,
        defaultSearch: false
    }
]
